;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsDropdownTriangle = function SvgPbsDropdownTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94a1b2",
    fillRule: "evenodd",
    d: "M6.765 6.469a.24.24 0 0 1-.326 0L.296.874A.242.242 0 0 1 .459.453h12.287c.221 0 .326.272.163.42z",
    clipRule: "evenodd"
  })));
};
export default SvgPbsDropdownTriangle;